import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { LLMChannelTemplateState, SLICE_NAME } from './models';

const llmChannelTemplateSelector = (state: RootState): LLMChannelTemplateState => state[SLICE_NAME];

export const selectChannelLLMTemplate = createSelector(
  llmChannelTemplateSelector,
  (state: LLMChannelTemplateState) => state.template,
);

export const selectChannelLLMTemplateIsLoading = createSelector(
  llmChannelTemplateSelector,
  (state: LLMChannelTemplateState) => state.isLoading,
);

export const selectChannelLLMTemplateError = createSelector(
  llmChannelTemplateSelector,
  (state: LLMChannelTemplateState) => state.error,
);
